import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTax = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "taxFreeProceeds",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17188",
		"data-name": "Group 17188",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12739",
				"data-name": "Path 12739",
				d: "M17.5,21H6.5a2,2,0,0,1-2-2V5a2,2,0,0,1,2-2h11a2,2,0,0,1,2,2V19A2,2,0,0,1,17.5,21Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12740",
				"data-name": "Path 12740",
				d: "M14,7.5h2",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12741",
				"data-name": "Path 12741",
				d: "M14,10.5h2",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12742",
				"data-name": "Path 12742",
				d: "M8,15h8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12743",
				"data-name": "Path 12743",
				d: "M8,18h8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12744",
				"data-name": "Path 12744",
				d: "M9.5,6.75V6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12745",
				"data-name": "Path 12745",
				d: "M9.5,11.25V12",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12746",
				"data-name": "Path 12746",
				d: "M8.2,10.714a1.081,1.081,0,0,0,.927.538h.822A1.053,1.053,0,0,0,10.2,9.177L8.8,8.825A1.053,1.053,0,0,1,9.053,6.75h.822a1.08,1.08,0,0,1,.925.536",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12747",
		"data-name": "Path 12747",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgTax;
